export default class PackageTicker {
  constructor(data) {
    this.Id = data.Id;
    this.TickerId = data.TickerId;
    this.PackageTickerId = data.PackageTickerId;
    this.Source = data.Source;
    this.Code = data.Code;
    this.Name = data.Name;
    this.Subfolder = data.Subfolder;
    this.Interval = data.Interval;
    this.ExcludeColumns = Array.isArray(data.ExcludeColumns) ? data.ExcludeColumns : [];
    this.VolumeDivisor = (data.VolumeDivisor === null || data.VolumeDivisor === undefined)
      ? null
      : data.VolumeDivisor;
    this.ColumnNamesMap = data.ColumnNamesMap && typeof data.ColumnNamesMap === 'object'
      ? { ...data.ColumnNamesMap }
      : {};
    this.UpdateTime = data.UpdateTime;
  }
}
